import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberOnly]'
})
export class NumberOnlyDirective {
  constructor(private element: ElementRef, private control: NgControl) { }
  @HostListener('input', ['$event']) onKeyDown(event) {
    const initalValue = this.element.nativeElement.value;
    this.element.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
    if (initalValue !== this.element.nativeElement.value) {
      this.control.control.setValue(this.element.nativeElement.value);
      event.stopPropagation();
    }
  }
}
